<template>
    <div>
        <form class="dealer-locator__form dealer-locator__container-filters" :class="{active: value}" method="GET" id="dealer-locator" action="/dealer-locator">
            <div class="dealer-locator__container-filters--title">
                <h2>Filter</h2>

                <button class="btn btn-transparent" type="button" @click="onClose">
                    <img src="/images/dealers/close-icon.svg" width="20" height="20" />
                </button>
            </div>

            <Location />
            <Brand />
            <Services />
            
        </form>
        <div class="dealer-locator__container-filters--overlay" @click="onClose"></div>
    </div>
</template>

<script>
    import { defineComponent } from "vue";
    import Location from "./Location.vue";
    import Brand from "./Brand.vue";
    import Services from "./Services.vue";

    export default defineComponent({
        name: 'Filters',

        components: {
            Location,
            Brand,
            Services
        },

        props: {
            value: Boolean,
        },

        methods: {
            onClose: function(){
                this.$emit('input', false)
            }
        }
    })
</script>